import React, { Component } from "react";
import { GridRow, GridColumn, Img, Button } from "arv-reactcomponents";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { Checkout } from "npmlinks-constants";
import { removePromoCode } from "../../../utils";

@inject("PromotionsStore", "CheckoutStore", "LoginStore")
@observer
class AppliedPromotionsView extends Component {
  constructor() {
    super();
    this.removePromo = this.removePromo.bind(this);
  }
  get appliedPromotions() {
    const { product } = this.props;
    return product.appliedPromotions || [];
  }
  removePromo(promo) {
    const { isRemoveable } = promo;
    if ( isRemoveable ) {
      removePromoCode();
      this.props.PromotionsStore.setRemoveSuccess(true);
      this.props.PromotionsStore.setSelectedPromo(null);
      const { isUserLoggedIn } = this.props.LoginStore;
      this.props.CheckoutStore.updateCart(null, isUserLoggedIn);
    }
  }
  render() {
    if (this.appliedPromotions.length === 0) {
      return null;
    }
    return (
      <GridRow>
        {this.appliedPromotions.map(promo => (
          <GridColumn key={promo.name}>
            <Button
              className="nw-applpromoview-removebutton"
              onClick={() => this.removePromo(promo)}
            >
              <Img src={Checkout.CHECKOUT_IMAGES.PROMOTION} />
              <span className="nw-applpromoview-promoname">{promo.name}</span>
              {promo.isRemoveable && (
                <span className="nw-applpromoview-promoclear">x</span>
              )}
            </Button>
          </GridColumn>
        ))}
      </GridRow>
    );
  }
}

AppliedPromotionsView.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
  }).isRequired,
  product: PropTypes.shape({}).isRequired,
  PromotionsStore: PropTypes.shape({
    setSelectedPromo: PropTypes.func.isRequired,
    setRemoveSuccess: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    updateCart: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("PromotionsStore", "CheckoutStore", "LoginStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AppliedPromotionsView.wrappedComponent,
  component: AppliedPromotionsView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CartProducts/AppliedPromotionsView/index.js